module.exports = __webpack_public_path__ + "static/media/flexible-image-5.bbdecc8f.jpg";